<template>
    <div class="form-group">
        <label :for="name">{{ title }} :</label>
        <div class="input-group col-xs-12">
            <input
              :readonly="readonly"
              :id="name"
              :name="name"
              :placeholder="placeholder"
              :type="type"
              class="form-control"
              :required="required"
              v-model="content"
              @input="handleInput"
              @keyup.enter="emitEnter"
            >
            <div v-if="unit != ''" class="input-group-addon">{{ unit }}</div>
        </div>
        <p class="text-center alert alert-danger" v-if="errors[name]">{{ errors[name][0] }}</p>
    </div>
</template>

<script>
    export default{
        name: 'vInput',
        props: {
            type: { default: 'text' },
            name: { default: '' },
            title: { default: '' },
            value: { default: '' },
            unit: { default: '' },
            placeholder: { default: '' },
            readonly:{ default: false },
            required:{
                type: Boolean,
                default: true
            }
        },
        data(){
            return{
                content: this.value,
                errors: {}
            }
        },
        mounted() {
            this.$emit('input', this.value === null ? '' : this.value)
            Event.listen('errors', (e) => {
                this.errors = e
            })
        },
        watch: {
          value: function(newVal, oldVal) {
            this.content = newVal
          }
        },
        methods: {
            handleInput (e) {
                this.$emit('input', this.content)
                this.$delete(this.errors, this.name)
            },
            emitEnter (e) {
              this.$emit('enter')
            }
        }
    };
</script>
